import React from 'react';

export interface SurveyStepContext {
    mode: "Design" | "Preview" | "Survey";
    stepType: "QuestionStep" | "FormStep" | "ConsentReviewStep";
    stepIdentifier: string;
    markdownFormat?: "Basic" | "GFM";
}

export const SurveyStepContext = React.createContext<SurveyStepContext>({ mode: "Survey", stepType: "QuestionStep", stepIdentifier: "1", markdownFormat: "Basic" });
